import { withRouter } from 'next/router';

const Header = () => (
  <>
    <ul id="menu1">
      <li>
        <a href="https://www.liffaclub.com">INICIO</a>
      </li>
      <li>
        <span className="separador">| </span>
        <a href="https://www.liffaclub.com/futbol-11.php">FUTBOL 11</a>
      </li>
      <li>
        <span className="separador">| </span>
        <a href="https://www.liffaclub.com/futbol-7.php">FUTBOL 7</a>
      </li>
      <li>
        <span className="separador">| </span>
        <a href="https://www.liffaclub.com/handball.php">HANDBALL</a>
      </li>
      <li>
        <span className="separador">| </span>
        <a href="https://www.liffaclub.com/intercolegial.php">INTERCOLEGIAL</a>
      </li>
      <li>
        <span className="separador">| </span>
        <a href="https://www.liffaclub.com/filosofia-liffa.php">FILOSOFIA</a>
      </li>
      <li>
        <span className="separador">| </span>
        <a href="https://www.liffaclub.com/historial.php">HISTORIAL</a>
      </li>
      <li>
        <span className="separador">| </span>
        <a href="https://www.liffaclub.com/delegados.php">DELEGADOS</a>
      </li>
      <li>
        <span className="separador">| </span>
        <a href="https://www.liffaclub.com/inter/inter-home.php">INTER ACADEMY</a>
      </li>
      <li>
        <span className="separador">| </span>
        <a href="https://www.liffaclub.com/lba/home.php">BASKETBALL</a>
      </li>
    </ul>

  </>
);

export default withRouter(Header);
